import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import messages from 'aurora-translations';

import { ADGMTextField, ADGMImage } from 'aurora-components';
import styles from './styles';

function FetchUser(props) {
  const { classes, title, formState, handleStateChange, fetchUser, isEditMode, fetchError, apiResponse } = props;

  return (
    <div>
      <div className={classes.panelTitle}>
        <Typography variant='h6'>{title}</Typography>
      </div>
      <div className={classes.subPanel}>
        {formState.userType === 'person' && (
          <div className={classes.fetchTextField}>
            <ADGMTextField
              id='userInputId'
              name='userInputId'
              variant='outlined'
              placeholder='000-0000-000000-0'
              type='text'
              mask={[
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
              ]}
              value={formState.userInputId || '' || apiResponse?.eidNumberOrUnified}
              onChange={handleStateChange}
              label={<FormattedMessage {...messages.EID_number} />}
              required
              disabled={isEditMode}
              customClasses={{ field: isEditMode && classes.calculatedField }}
            />
            <Button
              variant='contained'
              color='secondary'
              disabled={
                // !formState.userInputId ||
                // formState.userInputId?.length < 1 ||
                // isEditMode ||
                !formState.userInputId && !apiResponse?.eidNumberOrUnified
              }
              onClick={fetchUser}
            >
              <FormattedMessage {...messages.fetch_details} />
            </Button>

            {fetchError.messageShow && !isEmpty(fetchError.statusCode) ? (
              <div className={classes.errorToolTip}>
                <ADGMImage name='ErrorOrange.svg' alt='InformationImg' />
                {!isEmpty(messages[`error_${fetchError.statusCode}`]?.id) ? (
                  <FormattedMessage {...messages[`error_${fetchError.statusCode}`]} />
                ) : (
                  <FormattedMessage {...messages.oops_something_went_wrong} />
                )}
              </div>
            ) : (
              <>
                <div className={classNames(classes.infoAlert, classes.infoAlertBorder)} style={{ marginTop: '10px' }}>
                  <ADGMImage name='Information.svg' alt='Information icon' />
                  {formState.userType === 'person' && (
                    <FormattedMessage {...messages.Enter_EID_number_fetch_person_details} />
                  )}
                  {formState.userType === 'company' && (
                    <FormattedMessage {...messages.enter_commercial_license_number_to_fetch_company_details} />
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

FetchUser.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  isEditMode: PropTypes.bool,
  fetchUser: PropTypes.func.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  fetchError: PropTypes.object.isRequired,
  apiResponse: PropTypes.object.isRequired,
};

FetchUser.defaultProps = {
  isEditMode: false,
};

export default withStyles(styles)(FetchUser);
